import { useTranslation } from "react-i18next";
import DetailCollapseSection from "./DetailCollapseSection";

interface Props {
  question_ids: any;
  sectionId: string;
  isOpen: boolean;
  onToggle: (id: string) => void;
}

const QuestionAnswers = ({
  question_ids,
  sectionId,
  isOpen,
  onToggle,
}: Props) => {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === "ar";
  const count = question_ids?.length ?? 0;

  const icon = (
    <svg viewBox="0 0 20 20" fill="none" width="18" height="18">
      <path
        d="M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M10 13v.01M10 7.2V10"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );

  return (
    <DetailCollapseSection
      sectionId={sectionId}
      title={t("menu.questions")}
      icon={icon}
      count={count}
      isOpen={isOpen}
      onToggle={onToggle}
      isRtl={isRtl}
    >
      {count > 0 ? (
        <div className="ac-shop-detail__faq-list">
          {question_ids.map((question_id: any, index: number) => (
            <article
              key={question_id?.id ?? index}
              className="ac-shop-detail__faq-item"
            >
              <p className="ac-shop-detail__faq-q">
                <span className="ac-shop-detail__faq-q-mark" aria-hidden>
                  Q
                </span>
                <span className="ac-shop-detail__faq-q-text">
                  {question_id.question}
                </span>
              </p>
              <p className="ac-shop-detail__faq-a">
                <span className="ac-shop-detail__faq-a-mark" aria-hidden>
                  A
                </span>
                <span className="ac-shop-detail__faq-a-text">
                  {question_id.answer}
                </span>
              </p>
            </article>
          ))}
        </div>
      ) : (
        <div className="ac-shop-detail__empty">
          <span className="ac-shop-detail__empty-icon" aria-hidden>
            <svg viewBox="0 0 24 24" fill="none" width="28" height="28">
              <path
                d="M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Z"
                stroke="currentColor"
                strokeWidth="1.5"
              />
              <path
                d="M12 16v-4M12 8h.01"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </span>
          <p className="ac-shop-detail__empty-text">{t("services.message")}</p>
        </div>
      )}
    </DetailCollapseSection>
  );
};

export default QuestionAnswers;
